import { ArrowLeftIcon } from '@heroicons/react/20/solid';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function Spa() {
  const { i18n } = useTranslation('offer-package');

  const [isOpen, setIsOpen] = useState<boolean>(false);

  if (i18n.language === 'de') {
    return (
      <div className="bg-white grid md:grid-cols-2">
        <div className="bg-[#2ca67a] print:bg-white px-4 py-5 flex items-center">
          <div className="flex flex-col items-start gap-8 md:ml-10 lg:ml-20 py-10">
            {!isOpen && (
              <Fragment>
                <p className="text-white uppercase print:text-black flex flex-col text-4xl space-y-2 font-light">
                  <span>Hoteleigenes</span>
                  <span className="font-medium">Ayurveda Spa</span>
                </p>

                <button
                  type="button"
                  className="uppercase text-white py-4 px-6 border-white border-2"
                  onClick={() => setIsOpen(true)}
                >
                  Mehr erfahren
                </button>
              </Fragment>
            )}

            {isOpen && (
              <Fragment>
                <button
                  type="button"
                  className="uppercase text-white bg-[#155f4f] px-5 py-3 flex gap-2 items-center"
                  onClick={() => setIsOpen(false)}
                >
                  <ArrowLeftIcon className="size-6" /> zurück
                </button>

                <div className="text-white">
                  <ul className="list list-disc ms-5">
                    <li>Keltische Sauna „Lautrum“ 90 °C</li>
                    <li>Steirische Kräutersauna 65 °C</li>
                    <li>Mineralien-Dampfbad 45 °C</li>
                    <li>Sole-Sauna 75 °C</li>
                    <li>Infrarotsauna</li>
                    <li>Eisgrotte</li>
                    <li>Ruheraum Buddha's Place</li>
                    <li>
                      Gemütliche Ruheplätze im gesamten Bade- & Saunabereich
                    </li>
                  </ul>

                  <p className="mt-2">
                    Als Kur-Gast genießen Sie außerdem exklusiven Zutritt zu{' '}
                    <strong>Ganesha's</strong> Garden und zum Ruheraum{' '}
                    <strong>Ganesha's Spirit</strong>.
                  </p>
                </div>
              </Fragment>
            )}
          </div>
        </div>

        <div className="w-full h-full max-h-140">
          <img
            src="https://cdn.mandira-ayurveda.at/images/inquiry/wellness-sauna.webp"
            alt="Spa"
            className="w-full h-full object-cover"
          ></img>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white grid md:grid-cols-2">
      <div className="bg-[#2ca67a] print:bg-white px-4 py-5 flex items-center">
        <div className="flex flex-col items-start gap-8 md:ml-10 lg:ml-20 py-10">
          {!isOpen && (
            <Fragment>
              <p className="text-white uppercase print:text-black flex flex-col text-4xl space-y-2 font-light">
                <span>Hotel's own</span>
                <span className="font-medium">Ayurveda Spa</span>
              </p>

              <button
                type="button"
                className="uppercase text-white py-4 px-6 border-white border-2"
                onClick={() => setIsOpen(true)}
              >
                Learn more
              </button>
            </Fragment>
          )}

          {isOpen && (
            <Fragment>
              <button
                type="button"
                className="uppercase text-white bg-[#155f4f] px-5 py-3 flex gap-2 items-center"
                onClick={() => setIsOpen(false)}
              >
                <ArrowLeftIcon className="size-6" /> go back
              </button>

              <div className="text-white">
                <ul className="list list-disc ms-5">
                  <li>Celtic sauna “Lautrum” 90 °C</li>
                  <li>Styrian herbal sauna 65 °C</li>
                  <li>Mineral steam bath 45 °C</li>
                  <li>Brine sauna 75 °C</li>
                  <li>Infrared sauna</li>
                  <li>Ice grotto</li>
                  <li>Relaxation room Buddha's Place</li>
                  <li>
                    Comfortable resting places in the entire bathing & sauna
                    area
                  </li>
                </ul>

                <p className="mt-2">
                  As a spa guest, you also enjoy exclusive access to{' '}
                  <strong>Ganesha's</strong> Garden and to the relaxation room{' '}
                  <strong>Ganesha's Spirit</strong>.
                </p>
              </div>
            </Fragment>
          )}
        </div>
      </div>

      <div className="w-full h-full max-h-140">
        <img
          src="https://cdn.mandira-ayurveda.at/images/inquiry/wellness-sauna.webp"
          alt="Spa"
          className="w-full h-full object-cover"
        ></img>
      </div>
    </div>
  );
}

export default Spa;
